// Browser-safe compiler entry point. Node-only authoring helpers are imported by file
// in the API, worker, and adapter so the UI does not bundle server dependencies.
module.exports = {
    editableFields: require('./editableFields'),
    ensureDefaultProfileMenuId: require('./ensureDefaultProfileMenuId'),
    combineMetadata: require('./combineMetadata'),
    ...require('./roots')
};
